import { LinearProgress, Link } from '@material-ui/core';
import moment from 'moment';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { BodyDetails, Label, LeftRightPositioning, MoneyAmountValue, Space } from '@/components';
import DaysOutput from '@/components/output/DaysOutput';
import { makeSelectIsMobileView } from '@/model/global/selectors';
import { Limits } from '@/model/invoice/types';

interface InvoiceLimitsViewProps {
  value: Limits;
}

const selectIsMobile = makeSelectIsMobileView();

export const InvoiceLimitsView: React.FC<InvoiceLimitsViewProps> = ({ value: { monthly } }: InvoiceLimitsViewProps) => {
  const isMobile = useSelector(selectIsMobile);
  if (!monthly) {
    return <></>;
  }
  const percent = 100 - (monthly.currentAmount / monthly.amount) * 100;
  const LimitRefresh: React.FC = () => (
    <Label>
      <FormattedMessage
        id="invoice.components.limits.updates"
        values={{
          days: (
            <>
              ~
              <DaysOutput
                value={Math.round(moment.duration({ from: moment(), to: moment().endOf('month') }).asDays()) || 1}
              />
            </>
          ),
        }}
      />
    </Label>
  );
  const LimitIncrease: React.FC = () => (
    <Label>
      <Link href={`mailto:${window.env.SUPPORT_EMAIL}`}>
        <FormattedMessage id="invoice.components.limits.increase.link" />
      </Link>
    </Label>
  );
  return (
    <Space direction="vertical" style={{ flexGrow: 1 }} size={1.5}>
      <Space style={{ flexGrow: 1 }}>
        <BodyDetails>
          <FormattedMessage
            id="invoice.components.limits.left"
            values={{
              currentAmount: <MoneyAmountValue value={monthly.currentAmount} />,
              amount: <MoneyAmountValue value={monthly.amount} withCurrency />,
            }}
          />
        </BodyDetails>
      </Space>
      <LinearProgress
        className="ym-hide-content"
        variant="determinate"
        value={percent}
        style={{ borderRadius: '4px', height: '4px' }}
      />
      {isMobile ? (
        <Space direction="vertical" size={2}>
          <LimitRefresh />
          <LimitIncrease />
        </Space>
      ) : (
        <LeftRightPositioning left={<LimitRefresh />} right={<LimitIncrease />} />
      )}
    </Space>
  );
};

export default InvoiceLimitsView;
